export default class Projects {
  static JoinRoot = 'joinroot';
  static RootInc = 'root-inc';

  static all = [
    Projects.RootInc,
    Projects.JoinRoot,
  ];
}
